import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { useDispatch, useSelector } from 'react-redux'
import { reduxForm, Field } from 'redux-form'
import { connect } from 'react-redux'
import validateReportPropertyForm from 'app/validators/reportPropertyValidator'

import { Button, IonIcon, Modal, InputForm, TextAreaInputForm } from 'controls'
import { Row, Col } from 'flexbox'
import { DropDownForm } from 'controls/DropDown'
import PhoneInputForm from 'controls/PhoneInput'

import styles from './style'

const ReportPropertyForm = ({
  handleSubmit,
  handleCancel,
  loading,
  isPublicReport
}) => {
  const disableFields = !isPublicReport
  const reasons = useSelector(state => state.app.config.reasons)
  const reportReasons = reasons
    .filter(reason => reason.type === 'PROPERTY_COMPLAINT')
    .map(reason => ({ value: reason.id, label: reason.description }))

  return (
    <form className="form-container" onSubmit={handleSubmit}>
      <Row>
        <Col xs={12}>
          <h3>
            <strong>Selecciona alguna razón para reportar</strong>
          </h3>

          <p>
            Para mejorar la calidad de nuestro servicio nos gustaría saber ¿cúal
            es el motivo por el cual decidiste reportar ésta propiedad?.
          </p>
        </Col>
        <Col xs={12}>
          <Field
            component={DropDownForm}
            className="form-input-margin"
            label="Selecciona una de las razones para reportar está propiedad*"
            placeholder="Selecciona una razón..."
            options={reportReasons}
            name="reason"
          />
        </Col>
        <Col xs={12}>
          <Field
            component={InputForm}
            name="fullName"
            className="form-input-margin"
            label="Nombre completo*"
            disabled={disableFields}
          />
        </Col>
        <Col xs={6}>
          <Field
            component={InputForm}
            name="email"
            className="form-input-margin"
            label="Correo electrónico*"
            disabled={disableFields}
          />
        </Col>
        <Col xs={6}>
          <Field
            component={PhoneInputForm}
            name="telephone"
            className="form-input-margin"
            label="Teléfono*"
            disabled={disableFields}
          />
        </Col>
        <Col xs={12}>
          <Field
            rows={4}
            component={TextAreaInputForm}
            name="comment"
            className="form-input-margin"
            label="¿Deseas agregar más información sobre el reporte?"
            placeholder="Ingresa más información"
          />
        </Col>
        <Col xs={6}>
          <div className="container-button-control">
            <Button outline onClick={handleCancel} color="primary" fullWidth>
              Cancelar
            </Button>
          </div>
        </Col>
        <Col xs={6}>
          <div className="container-button-control">
            <Button
              outline
              type="submit"
              color="primary"
              fullWidth
              loading={loading}
            >
              Enviar
            </Button>
          </div>
        </Col>
      </Row>
      <style jsx>{styles}</style>
    </form>
  )
}

ReportPropertyForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  initialValues: PropTypes.object
}

const formConfig = {
  form: 'reportPropertyForm',
  enableReinitialize: true,
  validate: validateReportPropertyForm
}

export default reduxForm(formConfig)(ReportPropertyForm)
